<template>
  <v-row>
    <v-col>
      <v-row class="px-2 pt-2">
        <v-col>
          <v-expansion-panels>
            <v-expansion-panel v-test="{ panel: '' }">
              <v-expansion-panel-header>
                <div id="search">
                  <v-icon>
                    search
                  </v-icon>
                  {{ $t('Фильтры') }}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content eager @keydown.native.enter="focusOnBtn('searchBtn')">
                <v-row>
                  <v-col
                      class="py-0 my-0"
                      cols="12"
                      md="5"
                      lg="4">
                    <v-text-field
                        v-model="params.userName"
                        v-test="{ input: 'userName' }"
                        clearable
                        :label="$t('Имя пользователя')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      class="py-0 my-0"
                      cols="12"
                      md="5"
                      lg="4">
                    <v-text-field
                        v-model="params.contactPerson"
                        v-test="{ input: 'contactPerson' }"
                        clearable
                        :label="$t('Контактное лицо (ФИО)')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col
                      class="py-0 my-0"
                      cols="12"
                      md="5"
                      lg="4">
                    <v-text-field
                        v-model="params.organizationName"
                        v-test="{ input: 'organizationName' }"
                        clearable
                        :label="$t('Организация')"
                        hide-details
                        @keydown.native.enter="focusOnBtn('searchBtn')" />
                  </v-col>
                  <v-col class="text-right" align-self="center">
                    <btn-icon-tip
                        id="search"
                        ref="searchBtn"
                        icon="search"
                        icon-color="primary"
                        :tip="$t('Поиск')"
                        @click="search" />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <paginated-data-table
              v-if="getUserRegistrationRequests"
              ref="paginatedTable"
              :headers="headers"
              :items="requests"
              :loading="isLoading"
              item-key="requestId"
              :total-count="totalCount"
              :items-per-page="itemsPerPage"
              :request-method="getUserRegistrationRequests">
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.organizationName="{ item }">
              <route-link-with-tip
                  :text="item.organizationName"
                  :tip="$t('Просмотр организации')"
                  :to="{ path: `${urlRootPath}/organization/${item.organizationId}` }" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.userProfile.contactPerson="{ item }">
              {{ `${item.userProfile.contactPerson} (${item.userName})` }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.participantType="{ item }">
              {{ $t(PARTICIPANT_TYPE_ENUM[item.participantType]) }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestDate="{ item }">
              {{ item.requestDate
                ? $moment(item.requestDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.processDate="{ item }">
              {{ item.processDate
                ? $moment(item.processDate).format('DD.MM.YYYY HH:mm')
                : null }}
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.requestId="{ item }">
              <route-btn-tip
                  :id="item.userName"
                  :key="item.requestId"
                  :tip="tipText"
                  :icon="actionIcon"
                  :to="{ path: `${urlRootPath}/userRequestProcess/${item.requestId}` }" />
            </template>
          </paginated-data-table>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import RouteBtnTip from '@/components/reused/ui/RouteBtnTip.vue'
  import RouteLinkWithTip from '@/components/reused/ui/RouteLinkWithTip.vue'
  import PaginatedDataTable from '@/components/reused/ui/PaginatedDataTable.vue'
  import { PARTICIPANT_TYPE_ENUM } from '@/constants/enums'
  import { REQUEST_STATUSES } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { USER_REQUESTS } from '@/constants/store.js'

  export default {
    components: {
      BtnIconTip,
      RouteBtnTip,
      RouteLinkWithTip,
      PaginatedDataTable
    },
    props: {
      status: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        PARTICIPANT_TYPE_ENUM,
        isLoading: false,
        itemsPerPage: 10,
        params: {
          userName: '',
          organizationName: '',
          contactPerson: '',
          status: this.status
        }
      }
    },
    computed: {
      ...mapState(USER_REQUESTS.NAMESPACE, {
        requestsInfo: state => status => (state[USER_REQUESTS.STATE.REQUESTS][status] || {})
      }),
      totalCount () {
        return this.requestsInfo(this.status).totalCount || 0
      },
      requests () {
        return this.requestsInfo(this.status).items || []
      },
      processed () {
        return this.status === REQUEST_STATUSES.REJECTED ||
          this.status === REQUEST_STATUSES.APPROVED
      },
      headers () {
        let headers = [
          { text: this.$t('Организация'), sortable: false, value: 'organizationName' },
          { text: this.$t('Пользователь'), sortable: false, value: 'userProfile.contactPerson' },
          { text: this.$t('Категория участия'), sortable: false, value: 'participantType' },
          { text: this.$t('Дата подачи запроса'), sortable: false, value: 'requestDate' },
          { text: this.$t('Дата обработки запроса'), sortable: false, value: 'processDate' },
          { text: this.$t('Действия'), sortable: false, value: 'requestId' }
        ]
        if (!this.processed) {
          headers = headers.filter(h => h.value !== 'processDate')
        }
        return headers
      },
      actionIcon () {
        if (this.status === REQUEST_STATUSES.INPROCESS &&
          this.isAdmin) {
          return 'settings'
        }
        return 'visibility'
      },
      tipText () {
        return this.$t(this.status === REQUEST_STATUSES.INPROCESS &&
          this.isAdmin
          ? 'Обработка запроса'
          : 'Просмотр запроса')
      }
    },
    watch: {
      status: {
        immediate: true,
        handler (newStatus, oldStatus) {
          if (newStatus !== oldStatus) {
            this.params.status = newStatus
          }
        }
      }
    },
    created () {
      this.clearStore()
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(USER_REQUESTS.NAMESPACE, {
        getUserRegistrationRequestsAction: USER_REQUESTS.ACTIONS.GET_USER_REGISTRATION_REQUESTS,
        clearUserRegistrationRequestsAction: USER_REQUESTS.ACTIONS.CLEAR_USER_REGISTRATION_REQUESTS
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearUserRegistrationRequestsAction(this.status)
          ])
      },
      search: async function () {
        await this.$refs.paginatedTable.resetPaginationAndGetDataFromServer()
      },
      getUserRegistrationRequests: async function (params) {
        try {
          this.isLoading = true
          await this.getUserRegistrationRequestsAction({
            ...this.params,
            ...params
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
